import * as go from 'gojs';
import { TemplateCreator } from '../types';

export const createTemplateMap = <TTemplate>(
  ...creators: Array<TemplateCreator<TTemplate>>
): go.Map<string, TTemplate> => {
  const result = new go.Map<string, TTemplate>();
  creators.forEach(({ category, template }) => result.add(category, template));

  return result;
};
